export default "__VITE_ASSET__BY4LhdHv__"